import axios from "axios";
import store from "@/store";
import router from "@/router";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["X-Site-ID"] = process.env.VUE_APP_SITE_ID;

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("response", error);
    const { status } = error.response;

    if (status === 401 || error.response.data.status_code === 500) {
      store.commit("auth/SET_TOKEN", null);
      store.commit("auth/SET_USER", null);

      router.push({
        name: "login",
      });
    }

    return Promise.reject(error);
  }
);
